import { useEffect, useState } from "react";
import { graphql, useFragment } from "react-relay";

import { useArticleRenderContext } from "~/components/article/article-render/contexts";
import { useCurrentArticleIds } from "~/lib/current-item";
import { useFlag } from "~/lib/feature-flag";
import { useSnapshotState } from "~/lib/hooks";
import type { hooksIsShowTypeformArticle$key } from "~/queries/__generated__/hooksIsShowTypeformArticle.graphql";

export const useIsShowTypeform = (reference: hooksIsShowTypeformArticle$key) => {
  const article = useFragment(
    graphql`
      fragment hooksIsShowTypeformArticle on Article {
        entityUuid
      }
    `,
    reference,
  );

  const isTypeformEnabled = useFlag("enable_typeform");
  const [isShowTypeform, setIsShowTypeform] = useState(false);

  const { percentageReached } = useArticleRenderContext();
  const [snapshotPercentageReached] = useSnapshotState(percentageReached);
  const { currentArticleUuid } = useCurrentArticleIds();
  useEffect(() => {
    if (!isTypeformEnabled || snapshotPercentageReached === undefined) return;
    setIsShowTypeform(currentArticleUuid === article.entityUuid);
  }, [article.entityUuid, currentArticleUuid, isTypeformEnabled, snapshotPercentageReached]);

  return { isShowTypeform };
};
